<template>
  <div class="user-email-log-tab" ref="tab">
    <div class="flex center" v-if="Object.keys(userEmailLogs.data).length==0">
      <pre> No Data</pre>
    </div>

    <div v-if="$route.name === 'user-edit' && Object.keys(userEmailLogs.data).length">
      <div v-if="Object.keys(userEmailDetailsData).length">
        <div class="flex center demo-box">
          <div class="left-box">
            Email:
          </div>
          <div class="right-box box grow">
            <pre> {{ userEmailDetailsData.email }}</pre>
          </div>
        </div>
        <div class="flex center demo-box">
          <div class="left-box">
            Phone:
          </div>
          <div class="right-box box grow">
            <pre> {{ userEmailDetailsData.phone }}</pre>
          </div>
        </div>
        <el-row :gutter="20" >
          <el-col :span="6" class="flex center demo-box">

            <div class="left-box">
              First name:
            </div>
            <div class="right-box box grow">
              <pre>{{ userEmailDetailsData.first_name }}</pre>
            </div>

          </el-col>
          <el-col :span="6" class="flex center demo-box">

            <div class="left-box">
              Last name:
            </div>
            <div class="right-box box grow">
              <pre>{{ userEmailDetailsData.last_name }}</pre>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" >
          <el-col :span="6" class="flex center demo-box">
            <div class="left-box">
              Date Added:
            </div>
            <div class="right-box box grow">
              <pre> {{ userEmailDetailsData.created_at }}</pre>
            </div>
          </el-col>
          <el-col :span="6" class="flex center demo-box">
            <div class="left-box">
              Last activity:
            </div>
            <div class="right-box box grow">
              <pre> {{ userEmailDetailsData.last_session }}</pre>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" >
          <el-col :span="6" class="flex center demo-box">
            <div class="left-box">
              Last sent:
            </div>
            <div class="right-box box grow">
              <pre> {{ userEmailDetailsData.last_sent }}</pre>
            </div>
          </el-col>
          <el-col :span="6" class="flex center demo-box">
            <div class="left-box">
              Last ip:
            </div>
            <div class="right-box box grow">
              <pre> {{ userEmailDetailsData.last_ip }}</pre>
            </div>
          </el-col>
          <el-col :span="6" class="flex center demo-box">
            <div class="left-box">
              Last result:
            </div>
            <div class="right-box box grow">
              <pre> {{ userEmailDetailsData.last_result }}</pre>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="flex center">
        <div class="right-box box grow">
          <el-tabs v-model="activeName" >
            <el-tab-pane label="Log" name="log">
              <el-table
                  :data="userEmailLogs.data"
                  stripe>
                <el-table-column
                    label="Date">
                  <template slot-scope="scope">
                    <span >{{getDateEDTFormat(scope.row.date)}}</span>
                  </template>
                </el-table-column>
                <el-table-column

                    label="From">
                  <template slot-scope="scope">
                    <span >{{(scope.row.from)}}</span>
                  </template>
                </el-table-column>
                <el-table-column

                    label="Subject">
                  <template slot-scope="scope">
                    <span >{{(scope.row.subject)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Status">
                  <template slot-scope="scope">
                    <span >{{(scope.row.status)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Channel">
                  <template slot-scope="scope">
                    <span >{{(scope.row.channel)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="IP">
                  <template slot-scope="scope">
                    <span >{{(scope.row.ip)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Useragent">
                  <template slot-scope="scope">
                    <span >{{(scope.row.useragent)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="View">
                  <template slot-scope="scope">
                    <span >{{(scope.row.messageid)}}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="current_page"
                  @current-change="onChangePage"
                  :page-count="pagerMeta.last_page">
              </el-pagination>
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>


    </div>
  </div>
</template>

<script>

import request from '../../../servises/request'
import html2canvas from 'html2canvas';
import {mapGetters} from "vuex";

export default {
  name: 'UserEmailLog',
  props: {
    isScreenProcess: Boolean,
    isUserLogScreenProcess: Boolean,
    userData: Object,
    screenshotPage: HTMLDivElement
  },
  data () {
    return {
      activeName: 'log',
      current_page: 1,
      pagerMeta: {},

    }
  },
  computed: {
    ...mapGetters({
      userEmailDetailsData: 'users/userEmailDetails',
      userEmailLogs: 'users/userEmailLog'
    }),
  },
  created () {
    this.$store.dispatch('users/userEmailDetails',this.userData.email)
  },
  methods: {
    async createCanvas() {
      for (let i of [1, this.pagerMeta.last_page]) {
        this.current_page = i;
        await this.getUserLogs();

        this.screenshotPage.style.overflow = 'visible';
        this.screenshotPage.style.height = 'auto';
        const canvas = await html2canvas(this.screenshotPage, {
          scrollX: 0,
          scrollY: -window.scrollY,
          width: this.screenshotPage.offsetWidth,
          height: this.screenshotPage.scrollHeight,
        });
        const imgURL = {
          url: canvas.toDataURL('image/png'),
          name: `User email Log page_${i}`,
        };

        this.$emit('addNewImage', imgURL);

        if (i === this.pagerMeta.last_page) {
          this.$emit('triggerNextTab', null);
        }

        if (this.pagerMeta.last_page === 1) {
          break;
        }
      }
    },
    onChangePage(value) {
      this.current_page = value
      this.getUserLogs()
    },
    async getUserLogs() {
      await this.$store.dispatch('users/userEmailLog',{"id":this.userData.id, "email":this.userData.email, "from":this.userData.created_at, page: this.current_page})
      this.pagerMeta =this.userEmailLogs.meta
      return Promise.resolve(true);
    },
    getDateEDTFormat(date) {
      if(!date) {
        return
      }

      const options = {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };

      return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
    }
  },

  mounted  () {
    this.getUserLogs().then(resolve=>{
      if (this.isScreenProcess) {
        this.createCanvas();
      }
    })
  },
}
</script>
